import React from 'react'
import { Col, Row } from 'react-bootstrap'

export default function ProductMultiplierCalculation(props) {
    const { product, globleMultiplier, multiplier } = props
    const { brand_multiplier = 0, category_multiplier = 0, credit_card_fee = 0, product_multiplier = 0 } = globleMultiplier
    const globleMultip = product_multiplier || category_multiplier || brand_multiplier

    const price1 = parseFloat(((product.cost_price || 0) * (multiplier.multiplier || globleMultip)).toFixed(2))
    const shipping = parseFloat((price1 * ((multiplier.shipping_multiplier || 0) / 100)).toFixed(2))
    const price2 = price1 + shipping
    const card = parseFloat((price2 * ((product.credit_card_fee || credit_card_fee) / 100)).toFixed(2))
    const price = (price2 + card).toFixed(2)

    // console.log(price1, shipping, price2, ",", card, price)
    // const price = (((product.cost_price || 0) * (multiplier.multiplier || globleMultip)) * (1 + ((multiplier.shipping_multiplier || 0) / 100)) * (1 + ((product.credit_card_fee || credit_card_fee) / 100))).toFixed(2)


    // console.log(price, product.cost_price)
    // const profit = (price - (product.cost_price || 0))

    return (
        <React.Fragment>
            <Row className="align-items-center product-multiplier-calculation">
                <Col lg={6} md={6} className="pad-20 text-center">
                    <div className="d-flex product-subtotal justify-content-end">
                        <div className="text-left st-fw-400 st-fs-14 product-subtotal-item">Cost Price</div>
                        <div className="text-right st-fw-500 st-fs-18 product-subtotal-value">{product.cost_price || 0}</div>
                    </div>
                    <div className="d-flex justify-content-end">
                        <div className="product-multiplier-name">Category Multiplier</div>
                        <div className="multiplier-sign">x</div>
                        <div className="text-right st-fw-500 st-fs-18 product-multiplier-value">{(multiplier.multiplier || globleMultip)}</div>
                    </div>
                    <Row className="justify-content-end">
                        <Col lg={6} md={7}><div><hr className="mt-1 mb-1" /></div></Col>
                    </Row>
                    <div className=" product-subtotal d-flex text-right">
                        <div className="product-subtotal-item">Subtotal</div>
                        <div className="product-subtotal-value">{price1}</div>
                    </div>

                    <div className="d-flex">
                        <div className="product-multiplier-name">Shipping Multiplier</div>
                        <div className="multiplier-sign text-primary">+</div>
                        <div className="text-right st-fw-500 st-fs-18 product-multiplier-value text-primary">{shipping}</div>
                    </div>
                    <Row className="justify-content-end">
                        <Col lg={6} md={7}><div><hr className="mt-1 mb-1" /></div></Col>
                    </Row>
                    <div className=" product-subtotal d-flex text-right">
                        <div className="product-subtotal-item">Subtotal</div>
                        <div className="product-subtotal-value">{price2}</div>
                    </div>
                    <div className="d-flex">
                        <div className="product-multiplier-name">Credit Card Fee</div>
                        <div className="multiplier-sign text-primary">+</div>
                        <div className="text-right st-fw-500 st-fs-18 product-multiplier-value text-primary">{card}</div>
                    </div>
                    <Row className="justify-content-end">
                        <Col lg={6} md={7}><div><hr className="mt-1 mb-1" /></div></Col>
                    </Row>
                    <div className=" product-subtotal d-flex text-right">
                        <div className="product-subtotal-item">Total</div>
                        <div className="product-subtotal-value st-fw-700 st-fs-20">{price}</div>
                    </div>
                </Col>
                <Col lg={6} md={6}>
                    <Row>
                        <Col lg={12} md={12}>
                            <div className="app-card product-multiplier-modal mb-2" >
                                <div className="app-card-content st-default-rounded-block pad-15">
                                    <div className="text-center st-fs-15 st-fw-600 mb-2">
                                        Shipping Multiplier - Formula
                                    </div>
                                    <div className=" product-subtotal d-flex text-right">
                                        <div className="product-subtotal-item">Subtotal</div>
                                        <div className="product-subtotal-value">{price1}</div>
                                    </div>

                                    <div className="d-flex">
                                        <div className="product-multiplier-name">Shipping Multiplier</div>
                                        <div className="multiplier-sign">X</div>
                                        <div className="text-right st-fw-500 st-fs-18 product-multiplier-value">{multiplier.shipping_multiplier || 0}</div>
                                    </div>
                                    <Row className="justify-content-end">
                                        <Col lg={6} md={7}><div><hr className="mt-1 mb-1" /></div></Col>
                                    </Row>
                                    <div className=" product-subtotal d-flex text-right">
                                        <div className="product-subtotal-item">Subtotal</div>
                                        <div className="product-subtotal-value">{shipping * 100}</div>
                                    </div>
                                    <div className="d-flex">
                                        <div className="product-multiplier-name"></div>
                                        <div className="multiplier-sign">/</div>
                                        <div className="text-right st-fw-500 st-fs-18 product-multiplier-value ">100</div>
                                    </div>
                                    <Row className="justify-content-end">
                                        <Col lg={6} md={7}><div><hr className="mt-1 mb-1" /></div></Col>
                                    </Row>
                                    <div className="product-subtotal d-flex text-right">
                                        <div className="product-subtotal-item text-primary">Total</div>
                                        <div className="product-subtotal-value text-primary">{shipping}</div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={12} md={12}>
                            <div className="app-card product-multiplier-modal" >
                                <div className="app-card-content st-default-rounded-block pad-15 bg-gray">
                                    <div className="text-center st-fs-15 st-fw-600 mb-2">
                                        Credit Card Fee - Formula
                                    </div>
                                    {/* <div className="d-flex product-subtotal">
                                        <div className="text-left st-fw-400 st-fs-14 product-subtotal-item">Subtotal</div>
                                        <div className="text-right st-fw-500 st-fs-18 product-subtotal-value">8.8</div>
                                    </div>
                                    <div className="d-flex">
                                        <div className="product-multiplier-name">Subtotal</div>
                                        <div className="multiplier-sign">+</div>
                                        <div className="text-right st-fw-500 st-fs-18 product-multiplier-value ">11.88</div>
                                    </div>
                                    <Row className="justify-content-end">
                                        <Col lg={6} md={7}><div><hr className="mt-1 mb-1" /></div></Col>
                                    </Row> */}
                                    <div className=" product-subtotal d-flex text-right">
                                        <div className="product-subtotal-item">Subtotal</div>
                                        <div className="product-subtotal-value">{price2}</div>
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <div className="product-multiplier-name">Credit Card Fee</div>
                                        <div className="multiplier-sign">x</div>
                                        <div className="text-right st-fw-500 st-fs-18 product-multiplier-value ">{credit_card_fee}</div>
                                    </div>
                                    <Row className="justify-content-end">
                                        <Col lg={6} md={7}><div><hr className="mt-1 mb-1" /></div></Col>
                                    </Row>
                                    <div className=" product-subtotal d-flex text-right">
                                        <div className="product-subtotal-item">Subtotal</div>
                                        <div className="product-subtotal-value">{card * 100}</div>
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <div className="product-multiplier-name"></div>
                                        <div className="multiplier-sign">/</div>
                                        <div className="text-right st-fw-500 st-fs-18 product-multiplier-value ">100</div>
                                    </div>
                                    <Row className="justify-content-end">
                                        <Col lg={6} md={7}><div><hr className="mt-1 mb-1" /></div></Col>
                                    </Row>
                                    <div className="product-subtotal d-flex text-right ">
                                        <div className="product-subtotal-item text-primary">Total</div>
                                        <div className="product-subtotal-value text-primary">{card}</div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>

            </Row>
        </React.Fragment >
    )
}
